export const ASSETS = {
  mascot: "https://static.prod-images.emergentagent.com/jobs/1cfe0063-6ac0-410a-977c-713f3f05ddc2/images/71e547524223003b7525643a5cdf212f724eeb94abfd2e36713f5ae8f9f66ac5.jpeg",
  wordmark: "https://static.prod-images.emergentagent.com/jobs/1cfe0063-6ac0-410a-977c-713f3f05ddc2/images/280554134dfb64b5277623682bc0156aed8d7438290aaac34ddd1d56ea28c7a0.jpeg",
  sandwiches: [
    "https://images.pexels.com/photos/6416558/pexels-photo-6416558.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/photo-1554433607-66b5efe9d304?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1509722747041-616f39b57569?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  ],
  burgers: [
    "https://images.unsplash.com/photo-1610440042657-612c34d95e9f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1594212699903-ec8a3eca50f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1630384060421-cb20d0e0649d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  ],
  coffee: [
    "https://images.unsplash.com/photo-1572286258217-40142c1c6a70?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1579992357154-faf4bde95b3d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.pexels.com/photos/459489/pexels-photo-459489.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ],
  drinks: [
    "https://images.unsplash.com/photo-1629654613528-5d0a2e4166de?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1624552184280-9e9631bbeee9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  ],
  desserts: [
    "https://images.unsplash.com/photo-1524351199678-941a58a3df50?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1676300185983-d5f242babe34?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  ],
};

// fallback image per category name
export function categoryImage(catName, idx = 0) {
  const n = (catName || "").toLowerCase();
  if (n.includes("hamburger") || n.includes("burger")) return ASSETS.burgers[idx % 3];
  if (n.includes("frit")) return ASSETS.burgers[1];
  if (n.includes("caffet") || n.includes("caff") || n.includes("colazione")) return ASSETS.coffee[idx % 3];
  if (n.includes("bevand") || n.includes("drink")) return ASSETS.drinks[idx % 2];
  if (n.includes("dolc") || n.includes("dessert")) return ASSETS.desserts[idx % 2];
  return ASSETS.sandwiches[idx % 3];
}
